import { MutationTree } from 'vuex';
import { State } from './state';

import { AuthUser } from '@/models/AuthModels';

export enum MutationTypes {
  LoginSuccess = 'LOGINSUCCESS',
  RefreshLoginSuccess = 'REFRESHLOGINSUCCESS',
  Logout = 'LOGOUT',
}

export type Mutations = {
  [MutationTypes.LoginSuccess](state: State, authUser: AuthUser): void;
  [MutationTypes.RefreshLoginSuccess](state: State, authUser: AuthUser): void;
  [MutationTypes.Logout](state: State): void;
};

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.LoginSuccess](state: State, authUser: AuthUser) {
    state.authUser = authUser;

    localStorage.setItem('authUser', JSON.stringify(state.authUser));
  },

  [MutationTypes.RefreshLoginSuccess](state: State, authUser: AuthUser) {
    state.authUser = authUser;
    localStorage.setItem('authUser', JSON.stringify(state.authUser));
  },

  [MutationTypes.Logout](state: State) {
    state.authUser = null;
    localStorage.removeItem('authUser');
  },
};
